module.exports = __webpack_public_path__ + "img/p1-m.a5563c7e.jpg";